import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { PORTFOLIO_PATH, STORE_PATH } from '@/shared/config';

/**
 * 제작 유도 띠 — 흑연 판 위에 "이 사례처럼" 문구와 두 갈래 안내.
 * 견적 요청은 디자인(에디터)에서 시작하므로 상품 고르기(스토어)로 보낸다.
 */
export const PortfolioCta = (): ReactElement => (
  <section
    aria-labelledby="portfolio-cta-heading"
    className="flex flex-col gap-10 bg-primary px-6 py-14 text-white sm:px-12 sm:py-16 lg:flex-row lg:items-end lg:justify-between xl:px-16"
  >
    <div className="flex flex-col gap-4">
      <h2
        id="portfolio-cta-heading"
        className="text-[1.75rem] leading-tight font-bold tracking-[-0.03em] sm:text-[2.5rem]"
      >
        이 사례처럼 만들어 볼까요?
      </h2>
      <p className="max-w-xl text-[15px] leading-7 text-white/70 sm:text-base">
        상품을 고르고 에디터에서 디자인하면 바로 임시 견적을 확인하고 상담을 요청할 수 있어요.
      </p>
    </div>
    <div className="flex flex-wrap gap-3">
      <Link
        to={STORE_PATH}
        className="inline-flex h-12 items-center rounded-full bg-brand-lime px-7 text-[15px] font-semibold text-foreground transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        상품 고르러 가기
      </Link>
      <Link
        to={PORTFOLIO_PATH}
        className="inline-flex h-12 items-center rounded-full border border-white/40 px-7 text-[15px] font-medium transition-colors hover:bg-white hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        다른 사례 보기
      </Link>
    </div>
  </section>
);
